define((require) => {
    "use strict";

    const PublishView                            = require("ui/publish/PublishView");
    const ProjectDashboardChannelSetupManualView = require("ui/projects/publish/ProjectDashboardChannelSetupManualView");

    /**
     * Subclass of PublishView to initialize the Channel dashboard in a project context.
     * @class ProjectDashboardPublishView
     * @see PublishView
     * @see ProjectDashboardChannelSetupManualView
     */
    return PublishView.extend({

        channelSetupViewClass: ProjectDashboardChannelSetupManualView,

        /**
         * Invoked when any assets has been attached to the current project.
         *
         * Refreshes the current collection view to include the newly attached assets.
         */
        onAttachAsset() {
            this._channelSetupView.refresh();
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/publish/ProjectDashboardPublishView.js